import { Todo } from 'owa-todo-types';
import { TodoFilterFunction } from '../../schema/TodoFilterFunction';

export function andFilters(filters: TodoFilterFunction[]): TodoFilterFunction {
    return (todo: Todo) => filters.every(filter => filter(todo));
}
